import { render, staticRenderFns } from "./TdMembers.vue?vue&type=template&id=706138e2&"
import script from "./TdMembers.vue?vue&type=script&lang=js&"
export * from "./TdMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports